import { renderBuildUiImportsRenderer } from '@next-adapter/templates/renderers/generators/form/form-shared/build-ui-imports.js'
export function buildUiImports(ctx: {
  hasBoolean: boolean
  hasTextarea: boolean
  hasImage: boolean
  hasVideo: boolean
  hasMedia: boolean
  hasGallery: boolean
  hasIcon: boolean
  hasIconPostfix: boolean
  hasDate: boolean
  hasMarkdown: boolean
  hasRichtext: boolean
  hasSeparator: boolean
  hasSelect: boolean
  hasSelectCombobox: boolean
  hasCreatableSelect: boolean
  hasMultiSelect: boolean
  hasTabsField: boolean
  hasRelationship: boolean
  hasSimpleList: boolean
  hasNestedList: boolean
  hasNestedObjectList?: boolean
  hasCardContent?: boolean
  hasSectionCardHeading?: boolean
  hasFormRoot?: boolean
  hasButton?: boolean
  hasFormControls?: boolean
  hasInput?: boolean
}): string[] {
  const cardImports = ['Card']
  if (ctx.hasCardContent || ctx.hasSectionCardHeading) cardImports.push('CardContent')
  if (ctx.hasSectionCardHeading) cardImports.push('CardHeader', 'CardTitle')
  const formImports = [
    ctx.hasFormRoot === false ? '' : 'Form',
    ...(ctx.hasFormControls === false
      ? []
      : ['FormControl', 'FormDescription', 'FormField', 'FormItem', 'FormLabel', 'FormMessage'])
  ].filter(Boolean)

  const uiImports: string[] = [
    `import { ${cardImports.join(', ')} } from '@admin/components/ui/card'`,
    ctx.hasInput === false ? '' : "import { Input } from '@admin/components/ui/input'",
    formImports.length > 0
      ? renderBuildUiImportsRenderer({
          kind: 'renderBuildUiImportsImportsTemplate',
          props: { join: formImports.join(',\n  ') }
        })
      : ''
  ].filter(Boolean)

  if (ctx.hasButton !== false) {
    uiImports.unshift("import { Button } from '@admin/components/ui/button'")
  }

  if (ctx.hasBoolean) uiImports.push("import { Checkbox } from '@admin/components/ui/checkbox'")
  if (ctx.hasTextarea) uiImports.push("import { Textarea } from '@admin/components/ui/textarea'")
  if (ctx.hasImage || ctx.hasVideo || ctx.hasMedia)
    uiImports.push("import { MediaField } from '@admin/components/custom/media-field'")
  if (ctx.hasGallery)
    uiImports.push("import { GalleryField } from '@admin/components/custom/gallery-field'")
  if (ctx.hasIcon || ctx.hasIconPostfix)
    uiImports.push("import { IconPicker } from '@admin/components/custom/icon-picker'")
  if (ctx.hasDate)
    uiImports.push("import { DatePicker } from '@admin/components/custom/date-picker'")
  if (ctx.hasMarkdown || ctx.hasRichtext)
    uiImports.push("import { ContentEditor } from '@admin/components/custom/content-editor'")
  if (ctx.hasSeparator) uiImports.push("import { Separator } from '@admin/components/ui/separator'")
  if (ctx.hasSelect) {
    uiImports.push(
      renderBuildUiImportsRenderer({ kind: 'renderBuildUiImportsImportsDetailsTemplate' })
    )
  }
  if (ctx.hasRelationship || ctx.hasSelectCombobox) {
    const commandImports = [
      'Command',
      'CommandEmpty',
      'CommandGroup',
      'CommandInput',
      'CommandItem',
      'CommandList',
      ctx.hasCreatableSelect ? 'CommandSeparator' : ''
    ].filter(Boolean)
    uiImports.push(
      renderBuildUiImportsRenderer({
        kind: 'renderBuildUiImportsImportsDetailsBranchTemplate',
        props: {
          join: commandImports.join(',\n  ')
        }
      })
    )
    uiImports.push(
      renderBuildUiImportsRenderer({ kind: 'renderBuildUiImportsImportsDetailsBranchBodyTemplate' })
    )
  }
  if (ctx.hasMultiSelect) {
    uiImports.push("import { Badge } from '@admin/components/ui/badge'")
    uiImports.push(renderBuildUiImportsRenderer({ kind: 'renderTooltipImports' }))
  }
  if (ctx.hasTabsField) {
    uiImports.push(renderBuildUiImportsRenderer({ kind: 'renderTabsImports' }))
  }
  if (ctx.hasSimpleList)
    uiImports.push("import { DynamicListField } from '@admin/components/custom/dynamic-list-field'")
  if (ctx.hasNestedObjectList)
    uiImports.push(
      "import { NestedObjectListField } from '@admin/components/custom/nested-object-list-field'"
    )
  if (ctx.hasNestedList) {
    uiImports.push(renderBuildUiImportsRenderer({ kind: 'renderAccordionImports' }))
  }

  return uiImports
}
